// SIGNUP
export const SIGNUP = "auth/signup-via-email";
export const VERIFY_EMAIL = "auth/account/verify-email";
export const RESEND_VERIFICATION_LINK = "auth/account/resend-verification-link";
export const CHECK_VERIFICATION_STATUS =
  "auth/account/check-verification-status/";
export const VERIFY_TOKEN = "/auth/verify-token";
export const VALIDATE_SUB_DOMAIN = "/auth/validate-subdomain";
export const VALIDATE_AUTO_LOGIN = "/auth/validate-auto-login";
//LOGIN
export const LOGIN = "auth/login-via-email";
export const FORGOT_PASSWORD = "auth/forgot-password";
export const VERIFY_OTP = "auth/verify-otp";
export const RESET_PASSWORD = "auth/reset-password";
export const VALIDATE_UUID = "auth/validate-uuid";
export const NEW_USER_RESET_PASSWORD = "auth/new-user/reset-password";
export const SET_NEW_PASSWORD = "auth/set-new-password";
export const GET_LOGGED_IN_USER_DETAILS = "auth/regenerate-token";

// PLANS
export const GET_ALL_PLANS = "plans/lists";
export const START_FREE_TRIAL = "subscriptions/start-free-trial";
export const GET_CURRENT_SUBSCRIPTION = "subscriptions/my-current-subscription";
export const GET_BILLING_HISTORY = "subscriptions/transactions";
export const BUY_SUBSCRIPTION = "subscriptions/buy-subscription";
export const CHECK_PAYMENT_STATUS = "subscriptions/check-payment-status/";
export const DOWNLOAD_SUBSCRIPTION_INVOICE = "subscriptions/invoice/";
export const CANCEL_SUBSCRIPTION = "subscriptions/cancel";
export const CALCULATE_UPGRADE_PLAN_SUBSCRIPTION =
  "subscriptions/calculate-upgrade-plan-summary";
export const UPGRADE_PLAN = "subscriptions/upgrade-plan";

// ORGNISATION
export const SAVE_COMPANY_INFO = "account/save-company-info";
export const GET_COMPANY_PROFILE = "account/details";
export const GET_BRAND_LOGO = "account/details";
export const INITIALIZE_ORGNIZATION = "init";

// BRANCHES
export const GET_ALL_BRANCHES = "branch/all";
export const ADD_BRANCH = "branch/add";
export const UPDATE_BRANCH = "branch/update-branch";
export const GET_BRANCHES_LIST = "branch/list";
export const GET_BRANCH_DETAILS = "branch/details";
export const UPDATE_BRANCH_STATUS = "branch/update-status";
export const DELETE_BRANCH = "branch/delete";
export const BRANCH_LIST_BY_CITY = "branch/branch-list-by-city";
export const BRANCH_LIST_WITH_CITY = "branch/branch-list-with-city";
export const SYNC_LOCKS = "common/syncLocks";

// WORKSPACE, WORKSHOP, MEETING ROOMS
export const GET_ALL_WORKSPACES = "space/all";
export const ADD_WORKSPACE = "space/add";
export const GET_WORKSPACE_DETAILS = "space/details";
export const UPDATE_WORKSPACE = "space/update-space";
export const CASHBACK_UPDATE = "cashback/update";
export const UPDATE_WORKSPACE_STATUS = "space/update-status";
export const DELETE_WORKSPACE = "space/delete";
export const CLONE_SPACE = "space/clone-space";
export const GET_MEETING_ROOMS_LIST = "space/meeting-rooms-list";
export const GET_WORKSPACE_LIST = "space/work-space-list";
export const GET_WORKSPACE_BOOKING_DETAILS = "space/space-booking-details";
export const CHECK_ENTIRE_BRANCH = "space/space-booking-details-by-branch";
export const GET_ALL_WORKSHOP_REQUEST = "workshop-request/all";
export const GET_WORKSHOP_REQUEST_DETAILS = "workshop-request/details";
export const UPDATE_WORKSHOP_REQUEST_STATUS =
  "workshop-request/update-request-status";
export const UPDATE_WORKSHOP_REQUEST = "workshop-request/update-request";
export const GET_WORKSHOP_INVOICE = "space/workshop-invoice";
export const GET_SPACE_LIST_BY_TYPE = "space/space-list-by-type";
export const GET_ALL_WEBSITE_REQUESTS = "enquiry/all";
export const UPDATE_WORKSHOP_REQUEST_SHARE =
  "workshop-request/update-request-share";
export const GET_NEW_WORKSHOP_REQUEST_COUNT =
  "workshop-request/new-request-count";
export const UPDATE_NEW_WORKSHOP_REQUEST_COUNT =
  "workshop-request/update-new-request-count";
export const GET_ENABLE_DISABLE_SPACE_STATUS = "/space/enable-disable-status";
export const UPDATE_ENABLE_DISABLE_SPACE_STATUS =
  "/space/update-enable-disable-status";

// COUNTRIES
export const GET_ALL_COUNTRIES = "public/countries";

// CITIES
export const GET_ALL_CITY = "city/all";
export const GET_CITY_LIST = "city/list";
export const ADD_CITY = "city/add";
export const UPDATE_CITY = "city/update-city";
export const GET_CITY_DETAILS = "city/details";
export const UPDATE_CITY_STATUS = "city/update-status";
export const DELETE_CITY = "city/delete";
// REWARD
export const GET_REWARD_LIST = "rewards/list";
export const GET_CASHBACK_LIST = "cashback/list";
export const UPDATE_REWARD_SCREEN = "rewards/update-reward-screen";
export const UPDATE_REFERRAL_CODE = "rewards/update-referral-settings";
export const GET_REWARD_SETTING_LIST =
  "settings/rewards-settings-last-updated-info";

// AMENITIES
export const GET_ALL_AMENITY = "amenity/all";
export const GET_AMENITY_LIST = "amenity/list";
export const ADD_AMENITY = "amenity/add";
export const UPDATE_AMENITY = "amenity/update-amenity";
export const DELETE_AMENITY = "amenity/delete";
export const UPDATE_AMENITY_STATUS = "amenity/update-status";
export const GET_AMENITY_DETAILS = "amenity/details";

// USERS
export const GET_ALL_USERS = "user/all";
export const ADD_USER = "user/add";
export const UPDATE_USER = "user/details/update";
export const GET_USER_DETAILS = "user/details";
export const UPDATE_USER_STATUS = "user/details/update-status";
export const DELETE_USER = "user/delete";

// ROLES
export const GET_ALL_ROLES = "role/all";
export const GET_ROLES_LIST = "role/list";
export const ADD_ROLE = "role/add";
export const UPDATE_ROLE = "role/update-role";
export const ROLE_DETAILS = "role/details";
export const UPDATE_ROLE_STATUS = "role/update-status";
export const DELETE_ROLE = "role/delete";

// COUPONS
export const GET_ALL_COUPONS = "coupon/all";
export const ADD_COUPON = "coupon/add";
export const UPDATE_COUPON = "coupon/update-coupon";
export const GET_COUPON_LIST = "coupon/list";
export const GET_COUPON_DETAILS = "coupon/details";
export const UPDATE_COUPON_STATUS = "coupon/update-status";
export const DELETE_COUPON_STATUS = "coupon/delete";
export const CLONE_COUPON = "coupon/clone-coupon";

// GLOBAL SETTING
export const GET_GLOBAL_SETTINGS = "onBoardingScreen/list";
export const UPDATE_GLOBAL_SETTINGS = "settings/update-global-settings";
export const UPDATE_INTRO_PAGE_DETAILS = "onBoardingScreen/update-settings";
export const GET_PAGE_CONTENT = "common/page-content/get-by-type";
export const UPDATE_PAGE_CONTENT = "common/page-content/update-by-type";
export const GET_SETTINGS_LIST = "settings/global-settings-last-updated-info";
export const GET_BANKS_LIST = "common/banks";
export const API_LOGS = "api-logs/all";
export const API_LOG_DETAILS = "api-logs/details";

// CLOSURE
export const GET_ALL_CLOSURES = "closure/all";
export const ADD_CLOSURE = "closure/add";
export const GET_CLOSURE_DETAILS = "closure/details";
export const UPDATE_CLOSURE = "closure/details/update";
export const UPDATE_CLOSURE_STATUS = "closure/details/update-status";
export const DELETE_CLOSURE = "closure/delete";

// NOTIFICATION
export const GET_ALL_NOTIFICATIONS = "push-notification/all";
export const UPDATE_NOTIFICATION = "push-notification/details/update";
export const SEND_NOTIFICATION = "push-notification/broadcast";

// ORDERS
export const GET_ALL_ORDERS = "booking/getAll";
export const GET_ORDER_details = "booking/details";
export const CANCEL_ORDER = "booking/cancelBooking";

// CUSTOMERS
export const GET_ALL_CUSTOMERS = "customer/all";
export const GET_CUSTOMER_DETAILS = "customer/details";
export const UPDATE_CUSTOMER_STATUS = "customer/details/update-status";
export const ADD_CUSTOMER = "customer/add";
export const UPDATE_CUSTOMER = "customer/update";
export const GENERATE_ORDER_INVOICE = "booking/invoice";
export const GET_CUSTOMER_WALLET_TRANSACTIONS =
  "customer/getWalletTransactions";
export const GET_BOOKING_HISTORY = "customer/getUserBookings";
export const ADD_RECHARGE_TO_CUSTOMER_WALLET =
  "customer/rechargeCustomerWallet";
export const GET_CUSTOMERS_LIST = "customer/list";
export const GET_CUSTOMER_CHART_DETAILS = "customer/chart-details";
export const GET_PLATFORM_VERSIONS = "customer/platform-versions";

// DASHBOARD
export const GET_RATING_DASHBOARD_DETAILS = "ratings/dashboard-details";
export const GET_RATING_HISTORY = "ratings/history";
export const GET_OVERVIEW_DASHBOARD_DETAILS = "overview/dashboard-details";
export const GET_OVERVIEW_DASHBOARD_SPACE_DETAILS =
  "overview/dashboard-space-details";
export const GET_OVERVIEW_DASHBOARD_24_7_CHART =
  "overview/dashboard-24x7-chart";
export const GET_DASHBOARD_BOOKING_DETAILS = "booking/dashboard-details";
export const RATING_HISTORY_EXPORT = "ratings/export";
export const GET_OVERVIEW_DASHBOARD_CHART_DETAILS =
  "overview/dashboard-details-chart";
export const GET_OVERVIEW_COMPARISON_CHART = "overview/comparison-chart";

// OFFERS
export const GET_ALL_OFFERS = "/offer/all";
export const ADD_OFFER = "/offer/add";
export const UPDATE_OFFER = "/offer/update-Offer";
export const GET_OFFER_LIST = "/offer/list";
export const GET_OFFER_DETAILS = "/offer/details";
export const UPDATE_OFFER_STATUS = "/offer/update-status";
export const DELETE_OFFER_STATUS = "/offer/delete";
